<template>
  <div class="in-box">
    <Header @onRoleLogin="onRoleLogin" />
    <div class="integration-login">
      <div class="left"></div>
      <div class="right">
        <div class="login-box">
          <div class="title">{{ ROLE_MAP[role].name }}登录</div>
          <el-form ref="form" :model="form" :rules="rules" label-width="0" @submit.native.prevent>
            <el-form-item prop="account">
              <el-input v-model="form.account" placeholder="请输入手机号">
                <img slot="prefix" class="prefix" src="../../../assets/images/integration/phone.png" />
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="form.password" placeholder="请输入密码">
                <img slot="prefix" class="prefix" src="../../../assets/images/integration/password.png" />
              </el-input>
            </el-form-item>

            <div class="code-box">
              <el-form-item class="code-form-item" prop="imageCode">
                <el-input v-model="form.imageCode" placeholder="请输入验证码">
                  <img slot="prefix" class="prefix" src="../../../assets/images/integration/code.png" />
                </el-input>
              </el-form-item>
              <div class="code-content">
                <img @click="codeFn" v-if="codeImage" :src="codeImage" />
              </div>
            </div>
            <div class="operate">
              <div class="back" @click="backHome">
                <span>返回首页</span>
              </div>
              <div class="forget">
                <span @click="toPassword">忘记密码</span>
              </div>
            </div>
            <el-form-item>
              <el-button type="primary" class="login-button" v-loading="loading" @click="onSubmit" native-type="submit">{{
                ROLE_MAP[role].name }}登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "./components/header.vue";
import md5 from "@lib/encryption.js";
import BaseApi from "@lib/baseApi.js";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      form: {
        account: "",
        password: "",
        imageCode: "",
      },

      codeImage: "",

      rules: {
        account: [{ required: true, message: "请输入手机号", trigger: "blur" }, { pattern: /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/, message: '请输入正确格式的手机号', trigger: "blur"  }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        imageCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },

      // 身份 party mediate gzc
      role: "party", //
      ROLE_MAP: {
        party: {
          name: "当事人",
          homeUrl: process.env.VUE_APP_PARTY_HOME,
        },
        mediate: {
          name: "调解员",
          homeUrl: process.env.VUE_APP_MEDIATOR_HOME,
        },
        gzc: {
          name: "公证员",
          homeUrl: process.env.VUE_APP_GZC_HOME,
        },
      },

      // 通知调用方法
      fn: "",
    };
  },
  created() {
    if (this.$route.query.role) {
      this.role = this.$route.query.role || "party";
    }
    if (this.$route.query.fn) {
      this.fn = this.$route.query.fn;
    }
    if (this.$route.query.tip) {
      this.$message.error("用户名或密码错误");
    }
    let token = localStorage.getItem("token");
    if (this.fn) {
      this[this.fn]();
      token = ''
      return;
    }
    console.log(localStorage.getItem('token'));
    if (token) {
      location.href = this.ROLE_MAP[this.role].homeUrl + "?ht=" + token;
    }
  },
  mounted() {
    this.codeFn();
  },
  methods: {
    ...mapMutations(["setUserInfo", "setLocation"]),
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = {
            account: this.form.account,
            password: md5.md5(this.form.password),
            imageCode: this.form.imageCode,
          };
          BaseApi.createRpcToken(
            "/user/checkNotaryAccount",
            { notaryAccount: this.form.account },
            "post",
            "",
            "",
            false
          ).then((res) => {
            if (res.code == 200) {
              sessionStorage.setItem("gzcFlag", res.datas.existNotaryAccount);
              if (this.role === "gzc" && !res.datas.existNotaryAccount) {
                this.$message.error("当前账号暂无公证处权限");
                return;
              }
              BaseApi.createRpcToken("/user/login", data, "post", "", "", false)
                .then(
                  (data) => {
                    if (data.code == 200) {
                      if (data.datas.bizScope && data.datas.bizScope.indexOf('tj') < 0) {
                        localStorage.setItem('tjFlag', 1);
                      }

                      localStorage.setItem("token", data.datas.token);
                      localStorage.setItem("userId", data.datas.userId);
                      BaseApi.createRpcToken("/user/v2/getUserInfo").then(
                        (data) => {
                          sessionStorage.setItem(
                            "userInfo",
                            JSON.stringify(data.datas)
                          );
                          localStorage.setItem(
                            "curID",
                            data.datas.currentUserId
                          );
                          this.setUserInfo(data.datas);
                          localStorage.loginType = "password";
                          // this.$router.push({
                          //   path: "/personal/home",
                          // });
                          location.href = `${this.ROLE_MAP[this.role].homeUrl
                            }?ht=${localStorage.getItem(
                              "token"
                            )}&gzcFlag=${sessionStorage.getItem("gzcFlag")}`;
                        },
                        (err) => { }
                      );
                    } else {
                      this.notLogin = true;
                    }
                  },
                  (data) => {
                    if (data.code !== 200) {
                      this.$message({
                        message: data.message,
                        type: "error",
                      });
                    }
                    this.notLogin = true;
                    this.errorBox = true;
                    this.loading = false;
                    this.error = data.message;
                    this.codeFn();
                  }
                )
                .catch(function (e) {
                  errorLog(e);
                });
            }
          });
        }
      });
    },

    codeFn() {
      let date = new Date().getTime();
      BaseApi.createRpcToken(`/common/getCode?date=${date}`)
        .then(
          (data) => {
            this.codeImage = "data:image/png;base64," + data.datas.code;
          },
          (data) => {
            console.log(data);
          }
        )
        .catch(function (e) {
          errorLog(e);
        });
    },

    toPassword() {
      location.href = process.env.VUE_APP_PARTY_RESETPWD;
    },

    onRoleLogin(data) {
      this.role = data.role;
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          role: this.role,
        },
      });
    },
    logout() {
      localStorage.removeItem("token");
    },
    backHome() {
      location.href = process.env.VUE_APP_PARTY_INDEX;
    },
  },
  components: {
    Header,
  },
};
</script>
  
<style lang="scss" scoped>
.in-box {
  // display: flex;
  // flex-direction: column;
}

.integration-login {
  width: 100%;
  height: calc(100vh - 52px);
  display: flex;
  background: url("../../../assets/images/integration/bg.png") no-repeat top;
  background-size: 100% 100%;

  .left {}

  .right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 144px;
  }
}

.login-box {
  width: 500px;
  box-shadow: 0px 4px 20px 0px rgba(101, 7, 0, 0.1);
  padding: 32px 44px;
  border-radius: 4px;
  position: absolute;
  box-sizing: border-box;
  background-color: #ffffff;

  .title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
  }

  .prefix {
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }

  .code-box {
    display: flex;
    align-items: center;

    .code-form-item {
      flex: 1;
    }

    .code-content {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      margin-bottom: 22px;
      box-sizing: border-box;
      margin-left: 16px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .operate {
    display: flex;
    align-items: center;
    color: #bd3126;
    font-size: 14px;
    margin-bottom: 20px;

    .back {
      flex: 1;
    }

    span {
      cursor: pointer;
    }
  }

  .login-button {
    width: 100%;
    display: block;
    height: 44px;
    border-radius: 4px;
    background-color: #bd3126;
    border-color: #bd3126;
    font-size: 16px;
  }
}

::v-deep {
  .el-input--prefix .el-input__inner {
    // margin: 0 8px 0 12px;
    padding-left: 48px;
  }

  .el-input__prefix {
    padding-left: 12px;
    padding-right: 8px;
  }
}
</style>
  